<template lang="pug">
  .procurement-audit-and-send-email
    FinalReport(
      :data="subFinalScope"
      is-hidden
    )

    el-row(style="margin-left: 20px")
      el-col(:span="4") {{ $t('完成情况') }}
      el-col(:span="20")
        kpi-situation(
          :viewData="subFinalScope.kpi"
          :isEdit="false"
        )

    div(style="margin-left: 20px; margin-bottom: 20px")
      el-row(v-if="hasSync")
          el-col(:span="4") {{ $t('素材管理') }}
          el-col(:span="20")
            el-table(:data="matterTable")
              el-table-column(
                :label="$t('服务项目')"
                prop="service_item_name"
              )
              el-table-column(
                :label="$t('报价数量')"
                prop="number"
              )
              el-table-column(
                :label="$t('完成数量')"
                prop="complete_num"
              )

    QuotationInfo(
      :tableData="tableData"
      :quotationDetail="quotationDetail"
      :isBeyond="isBeyond"
    )

    template(v-if="marketRes.status !== null || LV3Res.status !== null")
      TitleBar {{ $t('市场部审核结果') }}
      div(style="margin-left: 20px")
        MarketAuditResult(
          :hasMarket="marketRes.status !== null"
          :hasLv3="isNeedLv3Approve"
          :market="marketRes"
          :lv3="LV3Res"
        )

    template(v-if="isNeedItApprove && ITRes.status !== null")
      TitleBar {{ $t('IT审核结果') }}
      div(style="margin-left: 20px")
        ProcurementAuditView(
          :status="ITRes.status"
          :time="ITRes.date"
          :remark="ITRes.comment"
        )

    TitleBar {{ $t('采购部审核') }}
    div(style="margin-left: 20px")
      MarketingAudit(
        :auditData="auditData"
        ref="audit"
      )
    el-row(
      v-if="!isView"
      style="margin-left: 20px"
    )
      el-col(
      :span="20"
      :offset="4"
      )
        footer-button(
          @confirm="submit"
          @cancel="$router.push('/campaign/process')"
        )
    SendEmailDialog(
      :visible="visible"
      :email="email"
      @cancel="visible = false"
      @confirm="handleSendEmail"
    )
    audit-versions(
      :id="subFinalScopeId"
      :businessType="$store.state.campaign.businessType"
      :auditType="11"
    )
</template>

<script>
import FinalReport from '@/components/FinalReport'
import KpiSituation from '@/components/KpiSituation'
import QuotationInfo from '@/components/QuotationInfo'
import TitleBar from '@/components/TitleBar'
import MarketingAudit from '@/components/MarketingAudit'
import ProcurementAuditView from '@/components/ProcurementAuditView'
import MarketAuditResult from '@/components/MarketAuditResult'
import FooterButton from '@/components/FooterButton'
import SendEmailDialog from '@/components/SendEmailDialog'
import axios from 'axios'
import {get} from 'lodash'
import AuditVersions from '@/components/AuditVersions'

const getCompletedProgress = subFinalScopeId => {
  return axios.get('/management/subfinal/getCompletedProgress', {
    params: {
      sub_final_scope_id: subFinalScopeId
    }
  })
}

const getVendorQuotation = (id, activePhaseType, phaseType) => {
  return axios.get('/management/subfinal/getVendorQuotation', {
    params: {
      sub_final_scope_vendor_id: id,
      phase_current: activePhaseType,
      phase_reality: phaseType
    }
  })
}

const approveFinalReport = params => {
  return axios.get('/management/subfinal/approveFinalReport', {params})
}

const getApproveResult = params => {
  return axios.get('/management/subfinal/getApproveResult', {params})
}

const fetchContact = campaignID => {
  return axios.get('/management/subfinal/getContactInfo', {
    params: {
      campaign_id: campaignID
    }
  })
}

const getVendorPriceOverview = id => {
  return axios.get('/management/subfinal/getVendorPriceOverview', {
    params: {
      sub_final_scope_vendor_id: id
    }
  })
}

const checkNeedItApprovePhase4 = id => {
  return axios.get('/management/subfinal/checkNeedItApprovePhase4', {
    params: {
      sub_final_scope_id: id
    }
  })
}

const checkNeedLv3Approve = id => {
  return axios.get('/management/subfinal/checkNeedLv3Approve', {
    params: {
      sub_final_scope_id: id
    }
  })
}

const defaultMatterTable = [
  {
    service_item_name: '—',
    number: '—',
    complete_num: '—'
  }
]

export default {
  components: {
    FinalReport,
    QuotationInfo,
    TitleBar,
    MarketingAudit,
    FooterButton,
    SendEmailDialog,
    ProcurementAuditView,
    KpiSituation,
    AuditVersions,
    MarketAuditResult
  },
  data () {
    return {
      visible: false,
      isBeyond: false,
      auditData: {
        result: 1,
        remark: null
      },
      subFinalScope: {
        sub_final_scope_name: null,
        approve_result: {}
      },
      cc: '',
      contact: {},
      tableData: {},
      quotationDetail: [],
      marketRes: {},
      LV3Res: {},
      ITRes: {},
      screenshotPath: '',
      isNeedLv3Approve: true,
      isNeedItApprove: false,
      matterTable: null,
      hasSync: false
    }
  },
  computed: {
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    },
    campaignID () {
      return this.$store.state.campaign.id
    },
    campaign () {
      return this.$store.state.campaign
    },
    email () {
      return this.auditData && this.auditData.result === 1
        ? get(this.contact['market'], 'mail', null)
        : this.subFinalScope.email
    },
    activePhaseType () {
      return this.$store.state.campaign.activePhaseType
    },
    phaseType () {
      return this.$store.state.campaign.phaseType
    }
  },
  mounted () {
    this.checkIfSync()
    this.fetchData()
    this.fetchAssets()
    if (this.isView) {
      this.getPurchaseApproveResult()
    }
  },
  methods: {
    checkIfSync () {
      axios
        .get('/management/subfinal/checkThirdParty', {
          params: {
            sub_final_scope_id: this.campaign.subFinalScopeId
          }
        })
        .then((res) => {
          this.hasSync = res.can_submit
        })
    },
    fetchAssets () {
      axios.get('/management/subfinal/getAssetList', {
        params: {
          sub_final_scope_id: this.campaign.subFinalScopeId
        }
      })
        .then(res => {
          this.matterTable = res.length !== 0 ? res : defaultMatterTable
        })
    },
    async fetchData () {
      const loading = this.$loading()
      const params = {
        id: this.campaign.subFinalScopeId,
        business_type: this.campaign.businessType
      }

      try {
        this.subFinalScope = await getCompletedProgress(this.subFinalScopeId)
        const [tableData, contact, marketRes, LV3Res, ITRes, isNeedLv3Approve, isNeedItApprove] = await Promise.all([
          getVendorPriceOverview(this.subFinalScope.sub_final_scope_vendor.sub_final_scope_vendor_id),
          fetchContact(this.campaign.id),
          getApproveResult({
            ...params,
            audit_type: 7
          }),
          getApproveResult({
            ...params,
            audit_type: 8
          }),
          getApproveResult({
            ...params,
            audit_type: 9
          }),
          checkNeedLv3Approve(this.subFinalScopeId),
          checkNeedItApprovePhase4(this.subFinalScopeId)
        ])

        this.tableData = tableData
        this.contact = contact
        this.isBeyond = this.subFinalScope.quotation_increased

        this.marketRes = marketRes
        this.LV3Res = LV3Res
        this.ITRes = ITRes
        this.isNeedLv3Approve = isNeedLv3Approve.is_need_marketing_lv3
        this.isNeedItApprove = isNeedItApprove.is_need_it
        const quotation = await getVendorQuotation(
          this.subFinalScope.sub_final_scope_vendor.sub_final_scope_vendor_id,
          this.activePhaseType,
          this.phaseType
        )
        if (this.$store.state.campaign.taskId == null) {
          this.$store.commit('campaign/setTaskId', quotation.task_id)
        }
        this.quotationDetail = quotation.vendor_price.map(o => {
          return {
            ...o,
            tableData: o.vendor_price
          }
        })
      } catch (err) {
        throw new Error(err)
      } finally {
        loading.close()
      }
    },
    async submit () {
      const validateResult = await this.$refs.audit.$validator.validate()
      if (!validateResult) return
      const params = {
        sub_final_scope_id: this.subFinalScopeId,
        approve_type: 4, // 审核类型 1：FinalScope 2：报价 3：SpotPlan 4-结案报告
        business_type: this.$store.state.campaign.businessType,
        task_name: this.$store.state.campaign.taskName,
        campaign_id: this.$store.state.campaign.id,
        approve_result: this.auditData.result === 1 ? 1 : 2,
        servlet_path: this.$route.path,
        remark: this.auditData.remark,
        task_id: this.$store.state.campaign.taskId
      }
      this.$message.success(this.$t('提交成功'))
      const loading = this.$loading()
      await approveFinalReport(params)
      loading.close()
      this.$router.push('/campaign/process')
    },
    handleSendEmail (email, cc) {
      this.cc = cc
      this.visible = false
      this.submit()
    },
    confirm () {
      this.visible = true
    },
    async getPurchaseApproveResult () {
      try {
        const result = await getApproveResult({
          id: this.campaign.subFinalScopeId,
          business_type: this.campaign.businessType,
          audit_type: 10
        })
        this.auditData = {
          result: result.status,
          remark: result.comment
        }
      } catch (err) {
        throw new Error(err)
      }
    }
  }
}
</script>
